module.exports = __webpack_public_path__ + "img/watage_res_19.263ed674.gif";